
import { defineComponent } from 'vue'
import Modal from '@/components/Modal/Modal.vue'
import SearchBar from '@/components/Nav/SearchBar.vue';

export default defineComponent({
	name: 'SearchModal',
	components: { Modal, SearchBar },
	data: () => ({
		modalOpen: false
	}),
	methods: {
		open () {
			this.modalOpen = true
		},
		close () {
			this.modalOpen = false
		},
	}
})
